import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FavoritesService} from './favorites.service';
import {Element} from '../element';

@Component({
    selector: 'favorites',      
    providers: [FavoritesService],      
    template: require('./favorites.component.html'),
})

export class MainFavoritesComponent implements OnInit{    

    router: Router;
    sellers: Element[];
    artisans: Element[];

    constructor(private _favoritesService: FavoritesService, _parentRouter: Router) {             
        this.router = _parentRouter;
    }
    
    ngOnInit() {                   
        this._favoritesService.getFavoritesSellersByUser().then(result => {
            this.sellers = result;                        
        }); 

        this._favoritesService.getFavoritesArtisansByUser().then(result => {
            this.artisans = result;
        });
    }

    favoriteClicked(element: Element) {

        this.router.navigate(['/main', 'elementdetail', {elementId: element.id}]);

    }

    backClicked() {
        this.router.navigate(['/main', 'dashboard']);
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/main/favorites/favorites.component.ts
 **/